import { render, staticRenderFns } from "./CbsDataSaveRecord.vue?vue&type=template&id=1ed9accf&scoped=true"
import script from "./CbsDataSaveRecord.vue?vue&type=script&lang=js"
export * from "./CbsDataSaveRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9accf",
  null
  
)

export default component.exports